import { Modal, ModalProps } from "react-bootstrap";
import styled from "styled-components";

export const BaseModal = styled(({ className, ...restProps }: ModalProps) => (
  <Modal dialogClassName={className} {...restProps} />
))`
  max-width: ${({ maxWidth }) => maxWidth || "927px"};
  width: ${({ width }) => width || "600px"};
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid var(--Neutral-N100, #e6e6e6);
  background: var(--Shade-White, #fff);

  /* Shadow/md */
  box-shadow:
    0 4px 8px -2px rgba(16, 24, 40, 0.1),
    0 2px 4px -2px rgba(16, 24, 40, 0.06);

  & > .modal-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-x: auto;
    padding: 24px;
    max-height: 92vh;
  }
`;
